export default {"src":"/_next/static/media/icon-commercialLand.a27dbbef.svg","height":26,"width":29,"blurWidth":0,"blurHeight":0};